// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f853458a","977":"a4919908"}[chunkId] + ".chunk.js";
};